import React from 'react'
import { ClickAwayListener, Tooltip, Typography } from '@mui/material'
import InfoRoundedIcon from '@mui/icons-material/InfoRounded'
import clsx from 'clsx'
import useStyles from './_styles/InformationalTooltipStyles'
import { InformationalTooltipProps } from './_props/InformationalTooltipProps'

/**
 * @description displays (i) icon with tooltip
 *
 */
export default function InformationalTooltip({
    title,
    disableFocusListener = true,
    placement = 'bottom',
    size = 'normal',
    withMarginRight = undefined,
}: InformationalTooltipProps) {
    const [open, setOpen] = React.useState(false)

    const handleTooltipClose = () => {
        setOpen(false)
    }

    const handleTooltipOpen = () => {
        setOpen(!open)
    }

    const classes = useStyles(size)

    return (
        <>
            {/* MOBILE TOOLTIP - SHOWS ON CLICK / TOUCH */}
            <ClickAwayListener onClickAway={handleTooltipClose}>
                <Tooltip
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    onClose={handleTooltipClose}
                    open={open}
                    placement={placement}
                    className={classes.mobileTooltip}
                    classes={{
                        tooltip: clsx(
                            classes.InformationalTooltipTooltip,
                            withMarginRight && classes.InformationalTooltipTooltipWithMargin,
                        ),
                        popper: classes.InformationalTooltipTooltipPopper,
                    }}
                    title={<div>{typeof title === 'string' ? <Typography>{title}</Typography> : title}</div>}
                >
                    <InfoRoundedIcon onClick={handleTooltipOpen} className={classes.InformationalTooltipIcon} />
                </Tooltip>
            </ClickAwayListener>

            {/* DESKTOP TOOLTIP - SHOWS ON HOVER */}
            <Tooltip
                disableFocusListener={disableFocusListener}
                placement={placement}
                className={classes.desktopTooltip}
                classes={{
                    tooltip: clsx(
                        classes.InformationalTooltipTooltip,
                        withMarginRight && classes.InformationalTooltipTooltipWithMargin,
                    ),
                    popper: classes.InformationalTooltipTooltipPopper,
                }}
                title={<div>{typeof title === 'string' ? <Typography>{title}</Typography> : title}</div>}
            >
                <InfoRoundedIcon className={classes.InformationalTooltipIcon} />
            </Tooltip>
        </>
    )
}
